module.exports = __webpack_public_path__ + "media/images/prizes/prize-img-45c0b6d4447d630613de5b903db96be8.jpg";